import type { LucideIcon } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '@/shared/components/ui/card';

type CareTypeCardProps = {
  icon: LucideIcon;
  title: string;
  body: string;
  className?: string;
};

export const CareTypeCard = ({ icon: Icon, title, body, className }: CareTypeCardProps) => (
  <Card className={className}>
    <CardHeader>
      <div className="flex items-center gap-2">
        <Icon className="h-6 w-6 text-bquest-teal" aria-hidden="true" />
        <CardTitle className="text-lg font-semibold">{title}</CardTitle>
      </div>
    </CardHeader>
    <CardContent>
      <p className="text-sm font-normal leading-relaxed text-muted-foreground">{body}</p>
    </CardContent>
  </Card>
);
